// @ts-nocheck
const config = {
  clientId: window.config?.clientId,
  redirectUri: window.config?.redirectUri,
  unifiedLoginHost: window.config?.unifiedLoginHost,
  tokenUrl: window.config?.tokenUrl,
  receiptUrl: window.config?.receiptUrl,
  portalUrl: window.config?.portalUrl,
  apiHost: window.config?.apiHost,
  imagesApiHost: window.config?.imagesApiHost,
  imagesCdn: window.config?.imagesCdn,
  systemStatusBucket: window.config?.systemStatusBucket,
  zipBucket: window.config?.zipBucket,
  environment: window.config?.environment,
  mailoutApiHost: window.config?.mailoutApiHost,
};

export default config;
